import React from 'react';
import { Button as MuiButton } from '@mui/material';

const CustomButton = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  startIcon,
  endIcon,
  onClick,
  type = 'button',
  sx = {},
  customStyles = {},
  ...props
}) => {
  // Default styles based on variant
  const getDefaultStyles = () => {
    switch (variant) {
      case 'contained':
        return {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 1,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          },
        };
      case 'outlined':
        return {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 1,
          borderWidth: 1,
          '&:hover': {
            borderWidth: 1,
          },
        };
      case 'text':
        return {
          textTransform: 'none',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
        };
      default:
        return {};
    }
  };

  // Layout only — MUI `color` prop drives palette (theme-aware)
  const getColorStyles = () => ({});

  // Size-specific styles
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          px: 2,
          py: 0.5,
          fontSize: '0.75rem',
          minHeight: '32px',
        };
      case 'medium':
        return {
          px: 3,
          py: 1,
          fontSize: '0.875rem',
          minHeight: '40px',
        };
      case 'large':
        return {
          px: 4,
          py: 1.5,
          fontSize: '1rem',
          minHeight: '48px',
        };
      default:
        return {};
    }
  };

  // Merge all styles
  const mergedStyles = {
    ...getDefaultStyles(),
    ...getColorStyles(),
    ...getSizeStyles(),
    ...customStyles,
    ...sx,
  };

  return (
    <MuiButton
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      sx={mergedStyles}
      {...props}
    >
      {children}
    </MuiButton>
  );
};

export default CustomButton;
